module.exports = __webpack_public_path__ + "static/media/people-carry.ec704335.svg";